import { render, staticRenderFns } from "./SubirVersion.vue?vue&type=template&id=2d221dda"
import script from "./SubirVersion.vue?vue&type=script&lang=js"
export * from "./SubirVersion.vue?vue&type=script&lang=js"
import style0 from "./SubirVersion.vue?vue&type=style&index=0&id=2d221dda&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d221dda')) {
      api.createRecord('2d221dda', component.options)
    } else {
      api.reload('2d221dda', component.options)
    }
    module.hot.accept("./SubirVersion.vue?vue&type=template&id=2d221dda", function () {
      api.rerender('2d221dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/SubirVersion.vue"
export default component.exports